export default {
    listagem: {
        titulo_pagina: 'Lista de Estados',
        novo: 'Añadir Nuevo Estado',
        table: {
            empty: "No se encontró ningún estado",
            editar: "Editar",
            nome: "Nombre"
        },
        filtro: {
            nome: "Nombre"
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Estado',
            editar: 'Editar Estado'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre del Estado'
            },
            status: {
                label: 'Estado',
                description: 'Estado activo o inactivo de Estado'
            },
            botao_salvar : 'Guardar Estado'
        },
        create: {
            success: "¡Estado creado con éxito!",
            error: "¡Error al crear el estado!"
        },
        update: {
            success: "¡Estado editado con éxito!",
            error: "¡Error al editar el estado!"
        }
    }
}
